import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  tooltip: {
    marginTop: '7px !important',
  },
  popper: {
    zIndex: 1000,
  },
}))

export default useStyles
